export default __webpack_public_path__ + "static/media/Smashed Avocado -proportioned_170.a99fba5b.jpg";